/**
 * What a viewer sees of another member's profile — one rule for the profile
 * page and the pop-up a restaurant opens from Messages (Kapil, 2026-09-25:
 * "they should see his full details, as they would if they were viewing his
 * profile page").
 *
 * Their Favorites show when the server sent them (the viewer is a
 * connection) or their profile is public — the server decides; this reads
 * what it sent.
 */
export function favoritesVisible(member) {
  if (!member) return false
  const sent = Array.isArray(member.favoritedRestaurants) && member.favoritedRestaurants.length > 0

  return sent || (member.profileVisibility === 'public' && member.favoritedRestaurantsCount > 0)
}
